import { call, put } from '@redux-saga/core/effects';
import { setLoading, setSubmitting } from 'src/redux/commonRedux/actions';
import appHandler from './appHandler';

export function* AuthHandler(api, action) {
  try {
    yield put(setSubmitting(true));
    const response = yield call(api, action.payload);
    handleSuccess(action, response);
  } catch (error) {
    handleError(action, error);
  } finally {
    yield put(setSubmitting(false));
  }
}

export function* APIHandlerWithSubmitting(api, action) {
  yield put(setSubmitting(true));
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleSuccess, handleError);
  yield put(setSubmitting(false));
}

export function* APIHandler(api, action) {
  yield put(setLoading(true));
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleSuccess, handleError);
  yield put(setLoading(false));
}
export function* APIHandlerWithoutLoading(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleSuccess, handleError);
}

export function handleSuccess(action, response) {
  if (action.onSuccess) {
    action.onSuccess(response);
  }
}

export function handleError(action, response) {
  if (action.onError) {
    action.onError(response);
  }
}
